import axios from "../axios/axios";
import {dataViewClient, dataViewProvider } from "../types/planning";


export const getDataView = async () => {
  const { data }: { data: dataViewProvider[] | dataViewClient[] } = await axios.get("/dataView");

  return data;
};
